import { store } from "../index";

// Returns the raw table_details object directly from Redux — no reconstruction needed.
export const getFSRFlow = () => {
  try {
    const sessionState = store.getState().sessionReducer || {};
    return sessionState.table_details || {};
  } catch (e) {
    return {};
  }
};

export const isFSR = () => {
  try {
    return store.getState().sessionReducer?.is_fsr === true;
  } catch (e) {
    return false;
  }
};

// The canonical table identifier — whatever the API put in table_details.table_id.
export const getFSRTableId = () => {
  const table = getFSRFlow();
  return table?.table_id || "";
};

// Returns the unified cache key for active table/tent orders
export const getFSRTableCacheKey = () => {
  const table = getFSRFlow();
  const session = store.getState().sessionReducer || {};
  return String(table?.table_id || session.tent_id || table?.table_no || session.location_id || "").trim() || "default";
};

// The display name for the table — use table_name from API, fall back to table_no.
export const getFSRTableDisplayName = () => {
  const table = getFSRFlow();
  return String(table?.table_name || table?.table_no || "").trim();
};

// Strip legacy "table_" or "tent_" prefixes if they appear in any value.
export const stripTablePrefix = (value) =>
  String(value || "").replace(/^table_|^tent_/i, "");
